import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { PedidoConfirmadoPage } from './index'

export function PedidoConfirmadoRota(): JSX.Element {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <PedidoConfirmadoPage
      idPedido={id}
      aoEncerrar={() => navigate('/catalogo', { replace: true })}
      aoAvaliar={(idPedido) => navigate(`/avaliacao/${idPedido}`)}
      pagoAoCancelar={(location.state as { pagoAoCancelar?: boolean } | null)?.pagoAoCancelar === true}
    />
  );
}
